"use client"

import { Card } from "antd"
import SearchingHotelsSkeleton from "../../FormSearch/desktop/SearchingHotels.skeleton"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"

const FormSearchDesktopSkeleton = () => {
  const isDesktop = useIsDesktop()

  if (!isDesktop) {
    return <></>
  }

  return (
    <Card
      size='small'
      hoverable
      variant="borderless"
      className="home__searching--form-panel"
      style={{
        position: 'absolute',
        bottom: '-4.9rem',
        width: 'calc(100% - 1rem)',
        left: '0.5rem'
      }}
    >
      <SearchingHotelsSkeleton size="small" />
    </Card>
  )
}

export default FormSearchDesktopSkeleton